import React, { PropTypes } from 'react';

class NewsRoot extends React.Component {
  static propTypes = {
    children: PropTypes.node
  };
  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

export default NewsRoot;




// WEBPACK FOOTER //
// ./src/components/News/NewsRoot.jsx